import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { Typography } from '@mui/material';
import React from 'react';
export function showDeleteEntityDialog(params) {
    showConfirmDialog({
        title: `${params.t('common.delete')} ${params.entity.toLowerCase()}`,
        content: React.createElement(Typography, null, params.t('common.deleteQuestion', { item: params.entity.toLowerCase() })),
        confirmLabel: params.t('common.delete'),
        onConfirm: () => params.onConfirm(),
    });
}
